class CloseAccountController {
    /*@ngInject*/
    constructor($log, $http, $timeout, $rootScope, CommonService) {
        $log.debug('CloseAccountController initialized');
        this.$log = $log;
        this.$http = $http;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.CommonService = CommonService;
    }

    closeAccount() {
        let url = this.CommonService.getBaseUrl() + '/account/close-account/execute';

        this.$http.post(url, null)
            .then(() => {
                window.location.replace(this.CommonService.getBaseUrl() + '/account/close-account');
            }, (error) => {
                this.$log.error('Error by closing the account: ' + error.status + ' ' + error.statusText);
            });
    }
}

export default CloseAccountController;
